<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              text
              @click="abrirDialogoPedido"
              :disabled="loading"
              style="margin-right: 20px"
            >Pedido</v-btn>
            <v-btn text @click="cancelar" :loading="loading" :disabled="loading">Cancelar</v-btn>
            <v-btn text @click="salvar" :loading="loading" :disabled="!form_valid">Salvar</v-btn>
          </v-toolbar-items>
        </v-app-bar>
        <v-form>
          <v-container fluid>
            <v-row dense>
              <v-col sm="3">
                <v-text-field label="Pedido" :value="pedido.id" disabled></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field label="Data" :value="pedido.data" disabled></v-text-field>
              </v-col>
              <v-col sm="3">
                <as-campo-valor label="Valor R$" :value="pedido.valor_liquido" disabled></as-campo-valor>
              </v-col>
              <v-col sm="3">
                <v-text-field label="Entrega" :value="pedido.entrega" disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="4">
                <v-text-field label="Cliente" :value="pedido.cliente.nome" disabled></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field label="Fornecedor" :value="pedido.fornecedor.nome_fantasia" disabled></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  label="Representante"
                  :value="pedido.representante.nome_fantasia"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense></v-row>
            <v-row dense></v-row>
          </v-container>
        </v-form>
      </v-card>

      <v-card>
        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" style="background-color: rgba(189, 189, 189, 0.3);">
            <v-col pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-data-table
          :search="pesquisa"
          :headers="headersSubpedido"
          :items="subpedido"
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
          :footer-props="{ itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }], itemsPerPageText: 'Registros Exibidos' }"
        >
          <template v-slot:item.acoes="{item}">
            <td>
              <v-tooltip top>
                Visualizar
                <v-btn slot="activator" icon @click="abrirModalGrade(item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </v-tooltip>
            </td>
            <td>
              <v-text-field v-model="item.entregue" type="number" :max="sub.quantidade" min="0"></v-text-field>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogoPedido" title="Seleção de Pedido" max-width="600px" hideCloseButton>
      <v-row dense>
        <p>
          <b>Digite o número do pedido que deseja fazer uma entrega.</b>
        </p>
      </v-row>
      <v-form ref="formPedido" lazy-validation v-model="form_valid">
        <v-row dense>
          <v-col sm="12">
            <v-text-field
              ref="pedido_id"
              type="number"
              v-model="pedido_id"
              label="Pedido Número"
              :rules="rulesForm.pedido"
              hintText="Pedido Número"
              @keyup.native.enter="copiarPedido"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <div slot="botoes">
        <v-btn color="default" @click="$refs.dialogoPedido.fechar()" :disabled="loading">Cancelar</v-btn>
        <v-btn color="primary" @click="copiarPedido" :loading="loading" :disabled="!form_valid">OK</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoGrade" title="Grade" max-width="600px" hideCloseButton>
      <v-form ref="formGrade" lazy-validation v-model="form_valid">
        <v-row dense>
          <v-col sm="12">
            <v-text-field label="Grade" v-model="subpedido_grade.grade"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <div slot="botoes">
        <v-btn color="primary" @click="fecharModalGrade" :disabled="loadingGrade">Não</v-btn>
        <v-btn color="primary" @click="salvarGrade" :loading="loadingGrade">Sim</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoEntregue" title="Pedido Entregue" max-width="1200px" hideCloseButton>
      <p>Este pedido já foi completamente entregue!</p>
      <div slot="botoes">
        <v-btn color="primary" @click="$refs.dialogoEntregue.fechar()">OK</v-btn>
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceEntregas from "@/services/entregas.js";
import { ptDateFormat } from "@/util/dateFormat.js";

export default {
  name: "EntregasForm",
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      loadingCancelar: false,
      loadingGrade: false,
      titulo: "Entrega",
      form_valid: true,
      exibirPesquisa: false,
      pesquisa: "",
      ptDateFormat,
      pedido_id: "",
      pedido: {
        id: "",
        data: "",
        valor_liquido: "",
        cliente: {
          nome: "",
        },
        representante: {
          nome_fantasia: "",
        },
        fornecedor: {
          nome_fantasia: "",
        },
      },
      subpedido: [],
      subpedido_grade: {},
      headersSubpedido: [
        { text: "Código", value: "codigo", width: "25%" },
        { text: "Descricao", value: "descricao", width: "25%" },
        { text: "Quantidade", value: "quantidade", width: "25%" },
        { text: "Entregue", value: "entregue", width: "25%" },
        { text: "", value: "acoes", sortable: false },
      ],
      rulesForm: {
        pedido: [(value) => !!value || "Obrigatório"],
      },
      erros: {
        pedido_id: "",
        pedidoInexistente: false,
        quantidade: "",
        botaoSalvar: false,
      },
    };
  },
  mounted() {
    this.$refs.dialogoPedido.abrir();
    setTimeout(() => {
      this.$refs.pedido_id.focus();
    }, 10);
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    abrirDialogoPedido() {
      this.$refs.dialogoPedido.abrir();
      setTimeout(() => {
        this.$refs.pedido_id.focus();
      }, 10);
    },
    async copiarPedido() {
      // this.erros.pedido_id = '';
      // this.erros.pedidoInexistente = '';
      if (this.$refs.formPedido.validate()) {
        if (this.pedido_id == "") {
          console.log("Este campo deve ser preenchido!");
        } else {
          try {
            this.loading = true;
            let response = await ServiceEntregas.copiarPedido(this.pedido_id);
            if (response.data.subentregas.length > 0) {
              this.pedido = response.data.pedido;
              this.subpedido = response.data.subentregas;
              this.pedido_id = "";
              this.subpedido.map((sub) => {
                sub.erro = "";
                return sub;
              });
            } else {
              this.pedido_id = "";
              this.$$refs.dialogoPedido.fechar();
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        }
      }
    },
    async salvar() {
      try {
        this.loading = true;
        this.subpedido.forEach((sub) => {
          if (sub.quantidade == null || sub.quantidade == "") {
            sub.quantidade = 0;
          }
        });
        let post = {
          pedido: this.pedido,
          subpedido: this.subpedido,
        };
        await ServiceEntregas.salvar(post);
        this.$router.push("/representantes/entregas");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirModalGrade(indice) {
      this.subpedido_grade = this.clone(this.subpedido[indice]);
      this.subpedido_grade.grade = JSON.stringify(
        this.subpedido_grade.grade,
        null,
        2
      );
      this.subpedido_grade.indice = indice;
      this.$refs.dialogoGrade.abrir();
    },
    fecharModalGrade() {
      this.subpedido_grade = {};
      this.$refs.dialogoGrade.fechar();
    },
    salvarGrade() {
      if (this.$refs.formGrade.validate()) {
        let indice = this.subpedido_grade.indice;
        this.subpedido_grade.grade = JSON.parse(this.subpedido_grade.grade);
        delete this.subpedido_grade.indice;
        this.subpedido[indice] = {};
        this.subpedido[indice] = this.subpedido_grade;

        let restante = 0;
        this.subpedido[indice].grade.forEach((grade) => {
          restante += grade.restante;
        });
        this.subpedido[indice].restante = restante;
        this.fecharModalGrade();
      }
    },
    cancelar() {
      this.$router.push("/representantes/entregas");
    },
  },
  watch: {
    subpedido: {
      handler: function (subpedido) {
        let botao = false;
        subpedido.forEach((sub) => {
          if (parseFloat(sub.restante) > sub.quantidade - sub.entregue) {
            sub.erro = "Quantidade Excedente";
            botao = true;
          } else if (sub.restante < 0) {
            sub.erro = "Quantidade Inválida";
            botao = true;
          } else {
            sub.erro = "";
          }
        });
        this.erros.botaoSalvar = botao;
      },
      deep: true,
    },
  },
};
</script>

<style>
/*  */
</style>
